<template>
    <div id="workOrderPreview">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Work Order Preview</div>
                    <div class="btn-groups text-right">
                        <button type="button" class="btn btn-primary" v-on:click="print()" >
                            <i class="fp-print"> </i> Print
                        </button>
                        <button type="button" class="btn btn-primary" v-on:click="downloadPdf()" >
                            <i class="fp-download"> </i> Download
                        </button>
                        <button type="button" class="btn btn-secondary" v-on:click="backBtn()" >
                            <i class="fp-back"> </i> Back
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container">
                            <div class="invoice-view-table" id="work_order_content">

                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';


import {commonMixins} from '../mixins/commonMixins';

export default {
    name: "WorkOrderPreview",
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: "Work Order Preview | " +process.env.COPYRIGHT_NAME
    },
    
    mixins:[commonMixins],
    data: () => ({
        loading:false,
        permissions:[],
        cantAccessPage:"",
        workOrderId : 0,
        path:"",
        flag:"",
        type:"preview",
        frmUrl:""
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'view_work_order') {
                    self.cantAccessPage = true;
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    mounted: function() {
        var self = this;
        var webloc = window.location.href;

        var decodeStr = "";

        if ( this.$route.query.data != '' && this.$route.query.data != undefined ) {

            decodeStr = atob(this.$route.query.data);

        }
        var url = new URL(webloc+"?"+decodeStr);
        self.workOrderId = url.searchParams.get("work_order_id");
        self.flag = url.searchParams.get("flag");
        if(url.searchParams.get("fromUrl")){
          self.frmUrl = url.searchParams.get("frmUrl")+"&fromUrl="+url.searchParams.get("fromUrl");
        }else{
          self.frmUrl = url.searchParams.get("frmUrl");
        }

       // console.log("work Order Id ::" + self.workOrderId + " flag :: " + self.flag+"  frmUrl  ::  "+self.frmUrl);
        self.getPermissions();
        self.previewWorkOrder("preview");
        self.path = process.env.API +  "/images/logo.png";
    },
    methods : {
        backBtn(){
            var self = this;
            if(self.frmUrl != "" && self.frmUrl != undefined){
              self.redirectPageUrl(self.frmUrl);
            }else{
              self.$router.push("/workorder/view/"+self.workOrderId);
            }

        },
        downloadPdf() {
            var self = this;
            self.previewWorkOrder("download");
        },
        previewWorkOrder(previewOrDownload) {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + '/work-order-print',
                type: "POST",
                data: {
                    wo_id:self.workOrderId,
                    flag:self.flag,
                    type:previewOrDownload
                },
                crossDomain: true,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {

                        if (previewOrDownload == "preview") {
                            var content = data.view;
                            setTimeout(function(){
                                // $("#print_rental_content").html("");
                                $("#work_order_content").html(content);
                            },500);
                            // var content = document.getElementById('work_order_view_content').innerHTML;
                            console.log(content);
                        }else{
                            var link = document.createElement('a');
                            document.body.appendChild(link);
                            link.href = data.content;
                            link.download = '';
                            link.target = "_blank";
                            link.click();
                        }

                    }

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'work-order-preview-download');
                }
            });
        },
        print() {
            var self = this;
            self.loading = true;
            var content = document.getElementById('work_order_content').innerHTML;
            console.log(content);
            var link = window.open(content, '_blank');
            link.document.write(content);
            link.document.close();
            self.loading = false;
            link.print();
            link.close();

        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/WorkOrderPreview.vue